import {
	TextField,
	FormControl,
	Select,
	MenuItem,
	InputLabel,
	InputAdornment,
	OutlinedInput,
	FormHelperText,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import styles from './EditLot.module.scss';
import CustomButton from '../../../layout/customButton/CustomButton';
import LotHistory from '../../history/LotHistory';
import { updateLot, updateLots } from '../../../../api/Siteplan/updateLots.api';
import { connect } from 'react-redux';
import { setAlert } from '../../../../redux/alerts/action';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
	MuiPickersUtilsProvider,
	KeyboardDatePicker,
} from '@material-ui/pickers';
import dayjs from 'dayjs';

const EditLot = ({
	editLotInfo,
	lotIdArr,
	closeEditLotsModal,
	coBrokers,
	salesAgents,
	uid,
	setAlert,
}) => {
	const [availablity, setAvailablity] = useState('');
	const [salesAgent, setSalesAgent] = useState('');
	const [coBroker, setCoBroker] = useState('');
	const [closingDate, setClosingDate] = useState();
	const [priceAddSubtract, setPriceAddSubtract] = useState('0');
	const [priceAddSubtractError, setPriceAddSubtractError] = useState(false);
	const [priceAddSubtractErrMsg, setPriceAddSubtractErrMsg] = useState('');

	useEffect(() => {
		if (editLotInfo) {
			setAvailablity(editLotInfo.availability);
			setSalesAgent(
				editLotInfo.assignedSalesAgent
					? editLotInfo.assignedSalesAgent
					: ''
			);
			setCoBroker(
				editLotInfo.assignedCoBroker ? editLotInfo.assignedCoBroker : ''
			);
			setClosingDate(editLotInfo.closingDate);
		} else {
			setAvailablity('');
			setSalesAgent('');
			setCoBroker('');
			setClosingDate();
		}
	}, [editLotInfo]);

	const handleAvailabilityChange = (e) => {
		setAvailablity(e.target.value);
	};

	const handleSalesAgentChange = (e) => {
		setSalesAgent(e.target.value);
	};

	const handleCoBrokerChange = (e) => {
		setCoBroker(e.target.value);
	};

	const handlePriceChange = (e) => {
		setPriceAddSubtract(e.target.value);
		clearPriceAddSubtractError();
	};

	const handleClosingDateChange = (date) => {
		let dateChanged = dayjs(date).format('YYYY-MM-DD');
		if (dateChanged !== 'Invalid Date') {
			setClosingDate(dateChanged);
		} else {
			setClosingDate();
		}
	};

	const handlePlus = () => {
		if (validatePriceValue(priceAddSubtract)) {
			clearPriceAddSubtractError();
			setPriceAddSubtract(Number(priceAddSubtract) + 5000);
		} else {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg('Invalid number.');
		}
	};

	const handleSubtract = () => {
		if (validatePriceValue(priceAddSubtract)) {
			clearPriceAddSubtractError();
			setPriceAddSubtract(Number(priceAddSubtract) - 5000);
		} else {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg('Invalid number.');
		}
	};

	const clearPriceAddSubtractError = () => {
		setPriceAddSubtractError(false);
		setPriceAddSubtractErrMsg('');
	};

	const validatePriceValue = (number) => {
		if (number === '') {
			return false;
		} else {
			if (!isNaN(number)) {
				return true;
			} else {
				return false;
			}
		}
	};

	const validatePositivePrice = () => {
		let finalLotPrice =
			Number(editLotInfo?.lotPrice) + Number(priceAddSubtract);
		if (finalLotPrice < 0) {
			return false;
		} else {
			return true;
		}
	};

	const handleEditLot = () => {
		// validate the price value entered
		if (!validatePriceValue(priceAddSubtract)) {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg('Invalid number.');
			return;
		}
		if (!validatePositivePrice()) {
			setPriceAddSubtractError(true);
			setPriceAddSubtractErrMsg(
				'Subtracting value is greater than the current elevation price.'
			);
			return;
		}

		if (editLotInfo) {
			// edit single lot
			let finalLotPrice =
				Number(editLotInfo.lotPrice) + Number(priceAddSubtract);

			updateLot(
				editLotInfo.lot,
				{
					salesAgent: salesAgent,
					coBroker: coBroker,
					lotAvailability: availablity,
					closingDate: closingDate,
					lotPrice: finalLotPrice,
				},
				uid
			);
			closeEditLotsModal();
		} else {
			// edit batch lots
			updateLots(
				lotIdArr,
				{
					salesAgent: salesAgent,
					coBroker: coBroker,
					lotAvailability: availablity,
					closingDate: closingDate,
					lotPriceChange: Number(priceAddSubtract),
				},
				uid
			);
			closeEditLotsModal();
		}
	};

	return (
		<div className={styles.edit_lot}>
			<div className={styles.history}>
				{editLotInfo ? (
					<LotHistory
						lotId={editLotInfo.lot}
						lotPrice={editLotInfo?.lotPrice}
					/>
				) : (
					<LotHistory lotIdArr={lotIdArr} />
				)}
			</div>
			<div className={styles.lot}>
				<h2 className={styles.lot_title}>Edit Lot Pricing</h2>
				<div className={styles.lot_edit_form}>
					<FormControl variant='outlined'>
						<InputLabel id='sales-agent'>Sales Agent</InputLabel>
						<Select
							labelId='sales-agent'
							value={salesAgent}
							onChange={handleSalesAgentChange}
							label='Sales Agent'
						>
							{salesAgents.map((salesAgent) => (
								<MenuItem
									value={salesAgent.salesAgentId}
									key={salesAgent.salesAgentId}
								>
									{salesAgent.salesAgentName}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl variant='outlined'>
						<InputLabel id='co-broker'>Co-Broker</InputLabel>
						<Select
							labelId='co-broker'
							value={coBroker}
							onChange={handleCoBrokerChange}
							label='Co-Broker'
						>
							{coBrokers.map((coBroker) => (
								<MenuItem
									value={coBroker.coBrokerId}
									key={coBroker.coBrokerId}
								>
									{coBroker.name}
								</MenuItem>
							))}
						</Select>
					</FormControl>
					<FormControl
						variant='outlined'
						error={priceAddSubtractError}
					>
						<InputLabel htmlFor='price-edit'>
							Price adding or subtracting
						</InputLabel>
						<OutlinedInput
							id='price-edit'
							className={styles.price_add_or_subtract}
							value={priceAddSubtract}
							labelWidth={205}
							onChange={handlePriceChange}
							inputProps={{
								autoComplete: 'off',
							}}
							startAdornment={
								<div>
									<CustomButton
										width={38}
										height={37}
										onClick={handleSubtract}
									>
										-
									</CustomButton>
								</div>
							}
							endAdornment={
								<div>
									<CustomButton
										width={38}
										height={37}
										onClick={handlePlus}
									>
										+
									</CustomButton>
								</div>
							}
						/>
						<FormHelperText>
							{priceAddSubtractErrMsg}
						</FormHelperText>
					</FormControl>
					<FormControl variant='outlined'>
						<InputLabel id='lot-availability'>
							Lot Availability
						</InputLabel>
						<Select
							labelId='lot-availability'
							value={availablity}
							onChange={handleAvailabilityChange}
							label='Lot Availability'
						>
							<MenuItem value='soldout'>Sold Out</MenuItem>
							<MenuItem value='pending'>Pending</MenuItem>
							<MenuItem value='available'>Available</MenuItem>
							<MenuItem value='hold'>Hold</MenuItem>
						</Select>
					</FormControl>
					<MuiPickersUtilsProvider utils={DateFnsUtils}>
						<KeyboardDatePicker
							inputVariant='outlined'
							variant='inline'
							format='yyyy-MM-dd'
							margin='normal'
							label='Closing Date'
							value={
								closingDate &&
								new Date(closingDate + 'T00:00:00')
							}
							onChange={handleClosingDateChange}
							KeyboardButtonProps={{
								'aria-label': 'closing date',
							}}
							minDate={new Date()}
						/>
					</MuiPickersUtilsProvider>
					<div className={styles.apply_btn}>
						<CustomButton
							width={166}
							height={42}
							onClick={handleEditLot}
						>
							Apply
						</CustomButton>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	coBrokers: state.siteplanManagement.coBrokers,
	salesAgents: state.siteplanManagement.salesAgents,
	uid: state.signIn.uid,
});
export default connect(mapStateToProps, { setAlert })(EditLot);
